<template>
  <div class="home_wrap">
    <div class="items-main">
      <div class="search_box">
        <input type="text" placeholder="输入购入产品" class="search_inp" />
        <i class="fdj" />
      </div>
    </div>
    <div class="item_wrap">
      <div class="items_3 item_margin">
        <van-empty v-if="listLength == 0" :description="$t('item.noData')" />
        <div v-for="i in data.list" :key="i.id" class="item">
          <div class="product-image">
            <img :src="`https:${i.img}`">
          </div>
          <div class="item_div1">
            <img src="../../views/images/index/bao.png" alt="" />
            <span>{{ i[lang] }}</span>
          </div>
          <div class="item-body">
            <div class="item_div2">
              <div class="item_rate">
                <p><img src="../images/index/rate.png" /></p>
                <p>日化利率</p>
                <p>{{ i.rate }}%</p>
              </div>
              <div class="item_day">
                <p><img src="../images/index/period.png" /></p>
                <p>认购期限</p>
                <p>{{ i.day }}分钟</p>
              </div>
              <div class="item_min">
                <p><img src="../images/index/money.png" /></p>
                <p>{{ $t('utils.startingAmount') }}</p>
                <p>￥{{ i.min }}</p>
              </div>
            </div>
            <div class="product-tag">
              <span>项目规模{{ i.total }}元</span>
              <span>到期反息反本</span>
            </div>
            <div class="item_div4">
              <div class="flex_bd">
                <div class="item-per">
                  <span>项目进度：</span>
                </div>
                <div class="item-progress">
                  <div class="flex_bd">
                    <van-progress
                      track-color="#b8b8b8"
                      color="#1989fa"
                      :percentage="i.percent"
                    />
                  </div>
                </div>
              </div>
              <div class="item_btn">
                <button v-if="i.percent < 100" type="button" @click="buy(i)">
                  立即认购
                </button>
                <button
                  v-if="i.percent >= 100"
                  class="item_btn_over"
                  type="button"
                  disabled
                >
                  {{ $t('utils.investOver') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <van-dialog
        v-model="show_tz"
        theme="round-button"
        :confirm-button-text="$t('utils.confirm')"
        @confirm="confirm"
      >
        <div class="close-x" @click="show_tz = false">
          <van-icon name="cross" />
        </div>
        <div class="show-body">
          <div class="sw-cell">
            <div class="sw-label">
              {{ sku[lang] }}
            </div>
            <div class="sw-bar">
              <div class="flex_bd">
                <van-field
                  v-model="number"
                  type="number"
                  :placeholder="$t('item.inputAmount')"
                />
              </div>
              <button class="all-in-btn" @click="investAll">全部投入</button>
              <div class="ut">RMB</div>
            </div>
          </div>
          <div class="sw-grid">
            <div class="flex_bd">
              <div class="sw-row">
                <div class="sw-info">
                  {{ $t('utils.yuji_sy') }}
                </div>
                <div class="sw-val">
                  {{ ((sku.rate * number) / 100).toFixed(5) }}
                </div>
              </div>
              <div class="sw-row">
                <div class="sw-val text-green">{{ sku.rate }}% [ RMB ]</div>
                <div class="sw-info">
                  {{ $t('utils.cankao_info') }}
                </div>
              </div>
            </div>
            <div class="sw-right">
              <div class="sw-label">RMB</div>
              <div class="sw-lg">{{ sku.day }}分钟</div>
              <div class="sw-info">
                {{ $t('utils.cycle') }}
              </div>
            </div>
          </div>
        </div>
      </van-dialog>
    </div>
  </div>
</template>

<script>
import Fetch from '../../utils/fetch'
import Api from '../../interface/index'
import Vue from 'vue'
import {
  Tab,
  Tabs,
  Progress,
  Empty,
  Dialog,
  Field,
  Sticky,
  Switch,
  Icon
} from 'vant'

Vue.use(Tab)
  .use(Tabs)
  .use(Progress)
  .use(Empty)
  .use(Dialog)
  .use(Field)
  .use(Sticky)
  .use(Switch)
  .use(Icon)

export default {
  name: 'Item',
  data() {
    return {
      lang: this.$i18n.locale || 'zh_cn',
      tabs: [
        this.$t('item.all'),
        this.$t('item.tab1'),
        this.$t('item.tab2'),
        this.$t('item.tab3'),
        this.$t('item.tab4'),
        this.$t('item.tab5'),
      ],
      tabs1: [
        {
          icon: require('../images/invest/icon1.png'),
          title: this.$t('item.all'),
        },
        {
          icon: require('../images/invest/icon2.png'),
          title: this.$t('item.tab1'),
        },
        {
          icon: require('../images/invest/icon3.png'),
          title: this.$t('item.tab2'),
        },
        {
          icon: require('../images/invest/icon4.png'),
          title: this.$t('item.tab3'),
        },
        {
          icon: require('../images/invest/icon1.png'),
          title: this.$t('item.tab4'),
        },
        {
          icon: require('../images/invest/icon2.png'),
          title: this.$t('item.tab5'),
        },
      ],
      active: 0,
      auto_close: [],
      data: [],
      listLength: 0,
      show_tz: false,
      number: '',
      sku: [],
      checked: true,
      userBalance: 0, // 新增：用户余额
    }
  },
  created() {
    this.$parent.footer('item')
  },
  mounted() {
    var type = 0
    if (this.$router.history.current.query.type) {
      this.active = parseInt(this.$router.history.current.query.type)
    }
    this.start(type)
    this.getUserBalance() // 获取用户余额
  },
  methods: {
    start(type) {
      Fetch('/index/item_search', {
        name: '',
        index_type: type,
      }).then((r) => {
        this.data = r.data
        this.listLength = r.data.list.length
      })
      Fetch('/index/item_auto').then((r) => {
        for (var i = 0; i < r.data.ids.length; i++) {
          this.auto_close.push(parseInt(r.data.ids[i]))
        }
      })
    },
    sort(type) {
      this.active = type
      this.start(type)
    },
    changeAuto(e) {
      console.log(e)
      Fetch('/index/item_auto_c', {
        pid: this.sku.id,
        tz_auto: this.checked ? 1 : 0,
      })
        .then((r) => {})
        .catch((err) => {
          this.psd_val = ''
        })
    },
    // 新增：获取用户余额
    getUserBalance() {
      Fetch('/user/info').then((r) => {
        if (r.code === 1 && r.data) {
          this.userBalance = r.data.money || 0; // 根据实际接口返回的余额字段调整
        }
      }).catch((err) => {
        console.error('获取用户余额失败:', err);
      });
    },
    
    // 新增：全部投入方法
    investAll() {
      // 获取用户可用余额
      const availableBalance = this.userBalance;
      
      // 获取项目最小投资金额
      const minAmount = this.sku.min;
      
      // 获取项目最大可投金额（根据进度计算）
      const remainingAmount = this.sku.total * (100 - this.sku.percent) / 100;
      
      // 计算可投金额：取用户余额、剩余可投金额的最小值
      let investAmount = Math.min(availableBalance, remainingAmount);
      
      // 确保不小于最小投资金额
      if (investAmount < minAmount) {
        if (availableBalance < minAmount) {
          this.$toast({
            className: 'toastName',
            message: `余额不足，最小投资金额为￥${minAmount}`,
          });
          return;
        }
        investAmount = minAmount;
      }
      
      // 设置投资金额
      this.number = investAmount.toFixed(2);
      
      this.$toast({
        className: 'toastName',
        message: `已设置全部投入金额：￥${this.number}`,
      });
    },
    
    buy(item) {
      this.sku = item
      const timestamp = (Date.parse(item.add_time)/ 1000) + (item.day * 60);
      const timestamp10 = Math.floor(Date.now() / 1000);
      
      if(timestamp < timestamp10 ){
        this.$toast({
          className: 'toastName',
          message: '认购时间已结束',
        });
        return false;
      }
      
      // 从接口获取用户信息
      Fetch('/user/info').then((r) => {
        if (r.code === 1 && r.data) {
          // 检查实名认证
          if (r.data.is_auth !== 1) {
            this.$toast({
              className: 'toastName',
              message: '请先完成实名认证',
            });
            this.$router.push('/setrealinfo');
            return false;
          }
          
          // 获取用户余额
          this.userBalance = r.data.money || 0;
          
          // 继续购买流程
          if (this.auto_close.indexOf(item.id) != -1) {
            this.checked = false;
          } else {
            this.checked = true;
          }
          this.show_tz = true;
          this.number = ''; // 重置输入金额
        }
      }).catch((err) => {
        console.error('获取用户信息失败:', err);
        this.$toast({
          className: 'toastName',
          message: '获取用户信息失败，请重试',
        });
      });
    },
    
    confirm() {
      console.log(this.sku);
      
      // 检查余额是否足够
      const investAmount = parseFloat(this.number);
      if (investAmount > this.userBalance) {
        this.$toast({
          className: 'toastName',
          message: '余额不足，请调整投资金额',
        });
        return false;
      }
      
      // 检查是否小于最小投资金额
      if (investAmount < this.sku.min) {
        this.$toast({
          className: 'toastName',
          message: `投资金额不能小于￥${this.sku.min}`,
        });
        return false;
      }
      
      // 检查是否超过项目剩余可投金额
      const remainingAmount = this.sku.total * (100 - this.sku.percent) / 100;
      if (investAmount > remainingAmount) {
        this.$toast({
          className: 'toastName',
          message: `投资金额超过项目剩余额度￥${remainingAmount.toFixed(2)}`,
        });
        return false;
      }
      
      // 计算到期时间戳（当前时间 + 项目分钟数）
      const currentTimestamp = Math.floor(Date.now() / 1000);
      const expiryTimestamp = currentTimestamp + (this.sku.day * 60); // day 是分钟数
      
      console.log('当前时间:', new Date(currentTimestamp * 1000));
      console.log('项目天数(分钟):', this.sku.day);
      console.log('计算后的到期时间:', new Date(expiryTimestamp * 1000));
      
      if (!this.number) {
        this.$toast({
          className: 'toastName',
          message: this.$t('item.inputAmount'),
        });
        return false;
      }
      
      Fetch('/index/item_apply', {
        id: this.sku.id,
        money: this.number,
        add_time: expiryTimestamp, // 传递到期时间戳
        language: this.lang
      })
        .then((r) => {
          console.log('投资成功，返回数据:', r);
          // 投资成功后更新用户余额
          this.userBalance -= investAmount;
          this.$router.push('/order');
        })
        .catch((err) => {
          console.error('投资失败:', err);
        });
    },
  }
}
</script>

<style lang="less" scoped>
  /deep/ .van-cell {
    padding: 15px 26px;
  }

  .home_wrap {
    overflow: hidden;
    width: 100%;
    min-height: 100vh;
    background: linear-gradient(to bottom, #5674d3, #fff);
  }

  .items-main {
    padding: 15px;
  }

  .search_box {
    width: 100%;
    height: 40px;
    background-color: #f6f6f6;
    border-radius: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 10px 0 14px;
    margin-top: 20px;

    .fdj {
      width: 16px;
      height: 16px;
      background: url(../images/item/fdj.png) no-repeat center center;
      background-size: 100% 100%;
    }

    .search_inp {
      flex: 1;
      font-size: 14px;
      color: #333;
      line-height: 20px;
      height: 20px;
    }
  }

  .tabs {
    background-color: #fff;
    padding: 16px 0 10px 0;
    border-bottom: 1px solid #ececec;
    position: fixed;
    width: 100%;
  }

  .tabs-head {
    height: 73px;
    overflow: hidden;
    position: relative;

    .tabs-head-scroll {
      width: 100%;
      height: 80px;
      overflow: scroll;
      white-space: nowrap;

      .tab-item {
        display: inline-block;
        text-align: center;
        width: 25%;

        .tab-icon {
          height: 51px;

          img {
            height: 100%;
          }
        }

        .tab-title {
          padding: 5px 0;
          color: #666666;
        }
      }

      .tab-item-active {
        .tab-title {
          color: #333333;
        }
      }
    }
  }

  .item_wrap {
    width: 100%;

    .tabs {
      z-index: 100;
    }
  }

  .items_3 {
    margin: 10px 15px;

    .item {
      background: #ffffff;

      .item-body {
        padding: 0px 15px 15px 0;
      }
    }
  }

  .flex_bd {
    flex: 1;
  }

  .item-progress {
    display: flex;
    align-items: center;
    height: 6px;
    border-radius: 40px;

    /deep/ .van-progress__pivot {
      display: none;
    }
  }
  
  .items_3 {
    .item {
      margin-bottom: 10px;
      border-radius: 10px;
      overflow: hidden;
      border: 1px solid #ebebeb;
      box-shadow: 2px 2px 5px rgba(115, 115, 115, 0.35);

      .item_div1 {
        display: flex;
        align-items: center;
        padding: 15px 10px;

        span {
          font-size: 16px;
        }

        img {
          width: 20px;
          height: 20px;
          margin-right: 4px;
        }
      }

      .item_div2 {
        display: flex;
        justify-content: space-between;
        text-align: center;
        font-size: 14px;
        padding: 0 20px;

        div {
          width: 30%;
          background-color: #f8f8f8;
          padding: 10px;

          p {
            padding: 5px 0;
          }
        }

        .item_rate {
          p:nth-child(1) {
            font-weight: bold;
            color: #f44844;
          }

          p:nth-child(2) {
            color: #999;
          }
        }

        .item_day {
          p:nth-child(1) {
            font-weight: bold;
          }

          p:nth-child(2) {
            color: #999;
          }
        }

        .item_min {
          p:nth-child(1) {
            font-weight: bold;
            font-size: 15px;
          }

          p:nth-child(2) {
            color: #999;
            font-size: 12px;
          }
        }
      }

      .item_div4 {
        padding: 5px 10px;
        display: flex;
        align-items: flex-end;
        margin-top: 10px;
        
        .item-per {
          color: #4a75f3;
          font-size: 16px;
          margin-bottom: 10px;
        }
        
        .item_btn {
          width: 24%;
          text-align: right;

          button {
            min-width: 75px;
            color: #fff;
            padding: 8px;
            border-radius: 5px;
            background-color: #4a75f3;
            margin-left: 14px;
            line-height: 16px;
            font-size: 14px;
          }

          .item_btn_over {
            color: #999;
            border: 1px solid #999;
            background-color: #fff;
          }
        }
      }
    }
  }

  .show-body {
    padding: 35px 20px 20px 20px;
    font-size: 14px;

    .sw-label {
      margin-bottom: 10px;
    }

    .sw-bar {
      display: flex;
      align-items: center;
      background-color: #f5f5f5;
      padding: 10px;
      border-radius: 4px;

      .flex_bd {
        color: #999999;
        flex: 1;
        margin-right: 10px;
      }
    }
  }

  .sw-bar .van-cell {
    padding: 0;
    background-color: transparent;
  }

  .sw-grid {
    display: flex;
    align-items: flex-end;
    margin-top: 20px;

    .sw-row:first-child {
      margin-bottom: 20px;
    }

    .sw-row > div:first-child {
      margin-bottom: 10px;
    }

    .sw-info {
      color: #999;
    }

    .sw-val.text-green {
      font-size: 16px;
    }
  }

  .sw-right {
    text-align: center;

    .sw-lg {
      font-size: 24px;
      margin-bottom: 10px;
    }
  }

  .product-image {
    width: 100%;
    padding: 10px;
    border-radius: 10px;
  }

  .product-image img {
    width: 100%;
    border-radius: 10px;
  }

  .product-tag {
    margin: 20px 10px 10px 10px;
  }

  .product-tag span {
    border: solid #e2e3e8 1px;
    color: #969696;
    padding: 4px;
    margin-right: 4px;
    border-radius: 4px;
    font-size: 14px;
  }
  
  /* 新增全部投入按钮样式 */
  .all-in-btn {
    background-color: #4a75f3;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 8px 12px;
    margin: 0 10px;
    cursor: pointer;
    font-size: 14px;
    white-space: nowrap;
    transition: background-color 0.3s;
  }
  
  .all-in-btn:hover {
    background-color: #3a65e3;
  }
  
  .all-in-btn:active {
    background-color: #2a55d3;
  }
  
  /* 调整sw-bar样式，适应新按钮 */
  .sw-bar {
    display: flex;
    align-items: center;
    background-color: #f5f5f5;
    padding: 10px;
    border-radius: 4px;
    
    .flex_bd {
      color: #999999;
      flex: 1;
      margin-right: 10px;
    }
    
    .all-in-btn {
      margin: 0 10px;
    }
    
    .ut {
      margin-left: 0;
    }
  }
  
  /* 响应式调整 */
  @media (max-width: 768px) {
    .all-in-btn {
      padding: 6px 10px;
      font-size: 12px;
      margin-left: 5px;
    }
    
    .sw-bar {
      padding: 8px;
      
      .all-in-btn {
        margin: 0 5px;
      }
    }
  }
  
  .close-x {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    z-index: 1;
  }
  
  ::v-deep .van-dialog__confirm {
    background: -webkit-linear-gradient(left, #03a9f48c, #4a75f3) !important;
    background: linear-gradient(to right, #03a9f48c, #4a75f3) !important;
  }
  
  ::v-deep .van-switch--on {
    background-color: #4a75f3 !important;
  }
</style>